// @flow

import { noop } from 'lodash';

import createReducer from '../utils/createReducer';
import switchFunc from '../utils/switchFunc';
import { API_CALL_FAILURE, API_CALL_SUCCESS, API_CALL_REQUEST } from '../constants/actionTypes';
import { LIVE_CHALLENGES } from '../constants/apiTypes';
import decodeChallenge from '../normalizers/decodeChallenge';

const initialState: LiveChallengesState = {
  challenges: [],
  errors: null,
  isFetching: false,
  isInitialised: false
};

const apiRequestReducer = switchFunc(
  {
    [LIVE_CHALLENGES]: (state, action) => ({
      errors: null,
      isFetching: !action.quiet
    })
  },
  () => noop
);

const apiSuccessReducer = switchFunc(
  {
    [LIVE_CHALLENGES]: (state, action) => ({
      isFetching: false,
      challenges: action.data.map(item => decodeChallenge(item, action.meta)),
      isInitialised: true
    })
  },
  () => noop
);

const apiFailureReducer = switchFunc(
  {
    [LIVE_CHALLENGES]: (state, action) => ({
      errors: action.errors,
      isFetching: false
    })
  },
  () => noop
);

export default createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => ({
    ...apiRequestReducer(action.api)(state, action)
  }),
  [API_CALL_SUCCESS]: (state, action) => ({
    ...apiSuccessReducer(action.api)(state, action)
  }),
  [API_CALL_FAILURE]: (state, action) => ({
    ...apiFailureReducer(action.api)(state, action)
  })
});
